export const bookingDataStore = {
  customerName: '',
  bookingId: ''
};